module.exports = __webpack_public_path__ + "img/yim05.addbb60a.jpg";